function isNumericKey(key = /* istanbul ignore next */ '') {
  return /^-?\d+$/.test(key);
}

function isSimpleKey(key = /* istanbul ignore next */ '') {
  return /^[a-zA-Z][a-zA-Z0-9]*$/.test(key);
}

function normaliseKey(key = /* istanbul ignore next */ '') {
  if (isNumericKey(key)) {
    return `[${key}]`;
  }

  if (!isSimpleKey(key)) {
    return `["${key.replace(/"/g, '\\"')}"]`;
  }

  return key;
}

module.exports = {
  normaliseKey,
  isNumericKey,
  isSimpleKey,
};
